import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ZusPodatkiService } from '../../@core/http/zus.service';
import { KlientService } from '../../@core/http/klient.service';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { ZusPodatki, Typ } from '../../shared/models/zus.model';
import { Klient } from '../../shared/models/klient.model';

@Component({
  selector: 'ngx-home-kh',
  templateUrl: './home-kh.component.html',
  styleUrls: ['./home-kh.component.scss']
})
export class HomeKhComponent implements OnInit, OnDestroy {

  zusData: ZusPodatki[];
  podatkiData: ZusPodatki[];
  klientData: Klient;
  zakresDat: ZakresDat;
  
  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly zusPodatkiService: ZusPodatkiService,
    private readonly klientService: KlientService
  ) { }

  ngOnInit(): void {
    this.loadKlientData();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.loadData();
  }

  private loadKlientData(): void {
    this.subscriptions.add(
      this.klientService.getKlient().subscribe(
        klient => {
          this.klientData = klient;
        },
        error => {
          console.error('Error loading client data:', error);
        }
      )
    );
  }

  private loadData(): void {
    if (!this.zakresDat) return;

    this.subscriptions.add(
      this.zusPodatkiService.getZusPodatki(this.zakresDat).subscribe(
        result => {
          const allData = result.razem || [];
          
          // Separate ZUS and tax data based on typ field
          this.zusData = allData.filter(item => item.typ === Typ.ZUS);
          this.podatkiData = allData.filter(item => item.typ === Typ.PODATKI);
        },
        error => {
          console.error('Error loading data:', error);
        }
      )
    );
  }

  onChangeTab($event) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
}
